// A row of choices of the search: the pills that Platea already has for a
// choice that is on or off (the quick selections of «Gestione delle fonti»,
// sidebar/panels.tsx, and the switches of «Indice», parliament/SectionIndex.tsx:
// aria-pressed, the circle icons, the accent when chosen), under the label of
// a field («Cerca la fonte»). The design of the search is not there yet: see
// docs/grafica/segnalazioni.md.
import { Button } from "@heroui/react";

import { Icon } from "../../components/Icon";

export type Choice<T extends string> = { value: T; label: string };

type ChoiceGroupProps<T extends string> = {
  label: string;
  choices: readonly Choice<T>[];
  isSelected: (value: T) => boolean;
  onPress: (value: T) => void;
  isDisabled?: boolean;
};

/** The label of a field, as «Cerca la fonte» has it (sidebar/panels.tsx). */
export const FIELD_LABEL_CLASS = "text-sm leading-6 font-medium text-accent";

export function ChoiceGroup<T extends string>({
  label,
  choices,
  isSelected,
  onPress,
  isDisabled,
}: ChoiceGroupProps<T>) {
  return (
    <div className="flex flex-col gap-1">
      <span className={FIELD_LABEL_CLASS}>{label}</span>
      <div role="group" aria-label={label} className="flex flex-wrap items-center gap-2.5">
        {choices.map(({ value, label: words }) => {
          const active = isSelected(value);
          return (
            <Button
              key={value}
              size="sm"
              isDisabled={isDisabled}
              onPress={() => onPress(value)}
              aria-pressed={active}
              className={`h-7 min-w-8 gap-1 rounded-2xl px-2.5 py-1 text-xs leading-5 font-medium ${
                active ? "bg-accent text-default" : "bg-white text-field-placeholder shadow-field"
              }`}
            >
              <Icon name={active ? "circleCheck" : "circle"} />
              {words}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
